import { env,brand } from "../src/services/envService";

export const dxApx = () => {
    const json = require("../src/env/tracking.json");
    const environment = env();
    const currentBrand = brand();
    const envData = [currentBrand + "_" + environment];
        var script = document.createElement("script");
        script.type = envData.type;
        script.id = envData.id;
        script.src = envData.src;
        script.setAttribute("data-profileUrl",envData['data-profileUrl']);
        script.setAttribute("data-tenantID",envData['data-tenantID']);
        script.setAttribute("data-appID",envData['data-appID']);
        script.setAttribute("data-appVersion",envData['data-appVersion']);
        script.setAttribute("data-use-axa-appname",envData['data-use-axa-appname']);
        script.setAttribute("data-appKey",envData['data-appKey']);
        script.setAttribute("async",envData['async']);
        document.head.prepend(script);
}